<template>
  <div class="locker-tweak">
    <!-- START PAGE-CONTAINER -->
    <div class="lock-container full-height">
      <!-- START PAGE CONTENT WRAPPER -->
      <div class="full-height sm-p-t-50 align-items-center d-md-flex">
        <div class="row full-width">
          <div class="col-md-5">
            <!-- START Lock Screen User Info -->
            <div class="d-flex justify-content-start align-items-center">
              <div class>
                <div class="thumbnail-wrapper circular d48 m-r-10">
                  <img
                    width="43"
                    height="43"
                    :data-src-retina="$store.state.avatar"
                    :data-src="$store.state.avatar"
                    alt
                    :src="$store.state.avatar"
                  />
                </div>
              </div>
              <div class>
                <h5 class="logged hint-text no-margin">Logged in as</h5>
                <h2 class="name no-margin">{{ userData.lname }}</h2>
              </div>
            </div>
            <!-- END Lock Screen User Info -->
          </div>
          <div class="col-md-7">
            <!-- START Lock Screen Form -->
            <form id="form-lock" role="form" @submit.prevent="login" ref="formContainer">
              <div class="row">
                <div class="col-md-12 rel-input">
                  <button type="button" class="arrowbtn bounce" value @click="login">
                    <i class="pg-arrow_lright_line_alt"></i>
                  </button>
                  <!-- START Form Control -->
                  <div class="form-group form-group-default">
                    <div class="row text__input__container">
                      <div class="col-md-11" @click="triggerFocus('password')" >
                        <label>Credentials</label>
                        <div class="controls" style>
                          <input
                            :type="visibility === true ? 'text' : 'password'"
                            class="form-control"
                            name="password"
                            id="password"
                            v-model="formModel.password"
                            placeholder="Password and Enter key"
                            autocomplete="off"
                          />
                        </div>
                      </div>
                      <span style="margin-top: 9px;" @click="() => { visibility = !visibility }" class=" lock__eye">
                        <i v-if="visibility === false" class="fa fa-eye"></i>
                        <i v-else class="fa fa-eye-slash"></i>
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <a href="#!" @click.prevent="logout"> Sign in as a different user </a>
                  </div>
                  <!-- END Form Control -->
                </div>
              </div>
              <!-- END Lock Screen Notification Icons-->
            </form>
            <!-- END Lock Screen Form -->
            <response-message :data="errorData" />
          </div>
        </div>
      </div>
      <!-- END PAGE CONTENT WRAPPER -->
    </div>
    <!-- END PAGE-CONTAINER -->
    <!-- START Lock Screen Footer Content-->
    <div class="pull-bottom lock__footer full-width">
      <div class="lock-container m-b-10 clearfix row">
        <div class="inline col-lg-3">
          <img
            src="/static/img/custom/quBit-blue-logo.png"
            alt
            class="m-t-5"
            data-src="/static/img/custom/quBit-blue-logo.png"
            data-src-retina="/static/img/custom/quBit-blue-logo.png"
            width
            height="35"
          />
        </div>
        <div class="col-lg-9">
          <p class="hinted-text small inline">
           QuBit Stamp is an electronic stamp that can be used for postal purposes, philately, document verification and the denotion of receipts and instruments.
          </p>
        </div>
      </div>
    </div>
    <!-- END Lock Screen Footer Content-->
  </div>
</template>
<style>
.locker-tweak {
  padding-top: 250px;
}
.modal-backdrop.show {
  display: none;
}

@media (max-height: 522px) {
  .lock__footer {
    display: none;
  }
}
@media(max-width: 374px) {
  .m-t-5 {
    padding-left: 15px;
  }

  .text__input__container {
    position: relative;
  }

  .lock__eye {
    position: absolute;
    right: 10px;
    top: 17px;
    height: 20px;
    bottom: 20px;
    margin-top: 0 !important;
  }
  
}


@media (max-width: 767px) {
  .eyewehseepass {
    position: absolute;
    right: 10px;
    top: 16px;
    bottom: 20px;
    margin-top: 0 !important;
  }
}

@media (min-width: 375px) and (max-width: 768px) {
  .lock__eye {
    top: 14px;
    height: 20px;
    position: absolute;
    right: 10px;
    bottom: 20px;
  }
}

@media(min-width: 1024px) {
  .m-t-5 {
    margin-bottom: 10px;
    margin-top: 0 !important;
  }
}

</style>

<script>
import ResponseMessage from "./ResponseMessage";
import triggerFocus from '../mixins/triggerFocus.js';
import validate from "../validate";

import http from "../$axios";

let pageData = {
  formModel: {
    user: "",
    password: "",
    signedIn: false,
    channel: "web",
    qlid: localStorage.getItem("_$_RD$___E23ed")
  },
  errorData: {},
  localUserData: {},
  id: "",
  visibility: false
};

let pageMethod = {
  ...mapActions(["refreshToken"]),
  login() {
    if (!validate("password", this.formModel.password)) {
      this.errorData = {
        message: "Please input a valid password",
        isError: true
      };
    } else {
      var loader = this.$loader(this, this.$refs.formContainer); // show loader
      this.errorData = { isError: false }; // hide error box
      let userToken;

      this.formModel.user = this.userData.username;
      this.axios
        .post(this.$store.state.rawURI + "daemon/auth/login", JSON.stringify(this.formModel))
        .then(response => {
          loader.hide();
          this.formModel.password = "";
          localStorage.removeItem("idle");

          if (localStorage.passport) {
            localStorage.passport = JSON.stringify({token: this.$encrypt(response.data.info.token, localStorage.keyAmus), token_generation: (response.data.timestamp * 1000)});
            userToken = localStorage.passport;
          }
          else {
            sessionStorage.passport = JSON.stringify({token: this.$encrypt(response.data.info.token, localStorage.keyAmus), token_generation: (response.data.timestamp * 1000)});
            userToken = sessionStorage.passport;
          }

          this.axios.defaults.headers.common["Authorization"] = "Bearer " + response.data.info.token;

          // eventBus.$emit("refreshToken", response.data); //Consumed in the main.js file
          this.$emit("loggedIn");
        })
        .catch(error => {
          console.log(error);
          loader.hide();

          this.errorData = {
            message: error.response
              ? error.response.data.message
              : "Sorry an error occured, check your internet",
            isError: true
          };
        });
    }
  },
  logout() {
    this.$store.commit('logout');
    localStorage.removeItem("last_url");
    $("#waiting").modal("hide");
    window.location = "/auth/login";
  }
};
import { mapState, mapActions } from "vuex";
export default {
  name: "Lockscreen",
  data() {
    return pageData;
  },
  methods: pageMethod,
  computed: {
    ...mapState(["userData"])
  },
  mixins: [ triggerFocus ],
  async mounted() {
    $(".arrowbtn").mouseover(function() {
      $(this).removeClass("bounce");
    });

    $(".arrowbtn").mouseout(function() {
      $(this).addClass("bounce");
    });
    var localUserData = this.$decrypt((localStorage.userData || sessionStorage.userData || null), localStorage.jekings);
    this.localUserData = JSON.parse(localUserData);
    this.id = this.localUserData.profiles[0].id.toString();

    this.visibility = false;
  },
  components: { ResponseMessage }
};
</script>

<style scoped>

</style>
